var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MainBase,{attrs:{"disabled":_setup.props.disabled},scopedSlots:_vm._u([{key:"tela-titulo",fn:function(){return [_vm._t("tela-titulo")]},proxy:true}],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }